module.exports = __webpack_public_path__ + "img/case11.ba3ae319.png";